export const COMMENT_ADD = 'COMMENT_ADD';
export const COMMENT_REMOVE = 'COMMENT_REMOVE';
export const ACTIVATE = 'ACTIVATE';
